[
  {
    "registrationNumber": "REG NL 10550",
    "name": "Avinew",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 6
  },
  {
    "registrationNumber": "PEI.V.02053.01.1",
    "name": "Avinew",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 74
  },
  {
    "registrationNumber": "REG NL 117276",
    "name": "Avinew Neo",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 7
  },
  {
    "registrationNumber": "PEI.V.02053.01.2",
    "name": "Avinew Neo",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 75
  },
  {
    "registrationNumber": "BE-V483306",
    "name": "Avinew Neo",
    "country": "BE",
    "waitingTime": 0,
    "plukonId": 42
  },
  {
    "registrationNumber": "REG NL 9620",
    "name": "Avipro Gumboro Vac",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 8
  },
  {
    "registrationNumber": "87a/78",
    "name": "Avipro Gumboro Vac",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 76
  },
  {
    "registrationNumber": "BE-V214952",
    "name": "Avipro Gumboro Vac",
    "country": "BE",
    "waitingTime": 0,
    "plukonId": 43
  },
  {
    "registrationNumber": "REG NL 6993",
    "name": "AviPro IB H120",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 182
  },
  {
    "registrationNumber": "A13/79",
    "name": "AviPro IB H120",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 77
  },
  {
    "registrationNumber": "REG NL 10511",
    "name": "Avipro IBD XTREME",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 9
  },
  {
    "registrationNumber": "PEI.V.03418.01.1",
    "name": "Avipro IBD XTREME",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 81
  },
  {
    "registrationNumber": "4",
    "name": "Avipro IBD XTREME",
    "country": "BE",
    "waitingTime": 0,
    "plukonId": 44
  },
  {
    "registrationNumber": "REG NL 6995",
    "name": "AviPro ILT",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 149
  },
  {
    "registrationNumber": "163A/87",
    "name": "AviPro ILT",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 183
  },
  {
    "registrationNumber": "REG NL 10493",
    "name": "Avipro ND C131",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 184
  },
  {
    "registrationNumber": "PEI.V.03159.01.1",
    "name": "Avipro ND C131",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 78
  },
  {
    "registrationNumber": "BE-V315314",
    "name": "Avipro ND C131",
    "country": "BE",
    "waitingTime": 0,
    "plukonId": 117
  },
  {
    "registrationNumber": "REG NL 6989",
    "name": "Avipro ND HB1",
    "country": "NL",
    "waitingTime": 7,
    "plukonId": 10
  },
  {
    "registrationNumber": "A11/79",
    "name": "Avipro ND HB1",
    "country": "DE",
    "waitingTime": 7,
    "plukonId": 185
  },
  {
    "registrationNumber": "5",
    "name": "Avipro ND HB1",
    "country": "BE",
    "waitingTime": 7,
    "plukonId": 45
  },
  {
    "registrationNumber": "200a/97",
    "name": "AviPro ND LaSota",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 79
  },
  {
    "registrationNumber": "REG NL 9978",
    "name": "Avipro precise",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 11
  },
  {
    "registrationNumber": "571a/91",
    "name": "Avipro precise",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 80
  },
  {
    "registrationNumber": "BE-V267662",
    "name": "Avipro precise",
    "country": "BE",
    "waitingTime": 0,
    "plukonId": 46
  },
  {
    "registrationNumber": "REG NL 10361",
    "name": "Avipro Salmonella vac T",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 207
  },
  {
    "registrationNumber": "252a/93",
    "name": "Avipro Salmonella vac T",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 147
  },
  {
    "registrationNumber": "BE-V315192",
    "name": "Avipro Salmonella vac T",
    "country": "BE",
    "waitingTime": 0,
    "plukonId": 120
  },
  {
    "registrationNumber": "PEI.V.11998.01.1",
    "name": "Avishield IB GI-13",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 145
  },
  {
    "registrationNumber": "PEI.V.11899.01.1",
    "name": "Avishield IB HD 120",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 111
  },
  {
    "registrationNumber": "REG NL 115900",
    "name": "Avishield ND",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 12
  },
  {
    "registrationNumber": "PEI.V.11742.01.1",
    "name": "Avishield ND",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 82
  },
  {
    "registrationNumber": "BE-V500764",
    "name": "Avishield ND",
    "country": "BE",
    "waitingTime": 0,
    "plukonId": 121
  },
  {
    "registrationNumber": "PEI.V.11928.01.1",
    "name": "Avishield ND B1",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 112
  },
  {
    "registrationNumber": "REG NL 112240",
    "name": "Ceva Ibird",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 14
  },
  {
    "registrationNumber": "PEI.V.11646.01.1",
    "name": "Ceva Ibird",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 84
  },
  {
    "registrationNumber": "BE-V441664",
    "name": "Ceva Ibird",
    "country": "BE",
    "waitingTime": 0,
    "plukonId": 48
  },
  {
    "registrationNumber": "REG NL  118336",
    "name": "Ceva Mass L",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 107
  },
  {
    "registrationNumber": "REG NL 111170",
    "name": "Cevac IBD 2512",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 13
  },
  {
    "registrationNumber": "7",
    "name": "Cevac IBD 2512",
    "country": "BE",
    "waitingTime": 0,
    "plukonId": 47
  },
  {
    "registrationNumber": "REG NL 122349",
    "name": "Evant \u002B Hipramune T 5000",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 140
  },
  {
    "registrationNumber": "EU/2/18/233",
    "name": "Evant \u002B Hipramune T 5000",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 186
  },
  {
    "registrationNumber": "REG NL 9476",
    "name": "Gallivac IB88",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 15
  },
  {
    "registrationNumber": "230a/97",
    "name": "Gallivac IB88",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 85
  },
  {
    "registrationNumber": "BE-V502986",
    "name": "Gallivac IB88",
    "country": "BE",
    "waitingTime": 0,
    "plukonId": 49
  },
  {
    "registrationNumber": "REG NL 7907",
    "name": "Gallivac IBD",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 16
  },
  {
    "registrationNumber": "10",
    "name": "Gallivac IBD",
    "country": "BE",
    "waitingTime": 0,
    "plukonId": 50
  },
  {
    "registrationNumber": "REG NL 119555",
    "name": "Hatchpak IB H120 NEO",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 144
  },
  {
    "registrationNumber": "PEI.V.03472.01.2",
    "name": "Hatchpak IB H120 NEO",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 187
  },
  {
    "registrationNumber": "REG NL 107963",
    "name": "Hipra Gumboro CW",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 17
  },
  {
    "registrationNumber": "PEI.V.11477.01.1",
    "name": "Hipra Gumboro CW",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 141
  },
  {
    "registrationNumber": "BE-V395333",
    "name": "Hipra Gumboro CW",
    "country": "BE",
    "waitingTime": 0,
    "plukonId": 51
  },
  {
    "registrationNumber": "REG NL 100192",
    "name": "Hipracox Broilers",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 18
  },
  {
    "registrationNumber": "BE-V320625",
    "name": "Hipracox Broilers",
    "country": "BE",
    "waitingTime": 0,
    "plukonId": 52
  },
  {
    "registrationNumber": "REG NL 10154",
    "name": "Hipragumboro-GM97",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 19
  },
  {
    "registrationNumber": "PEI.V.03018.01.1",
    "name": "Hipragumboro-GM97",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 86
  },
  {
    "registrationNumber": "BE-V267005",
    "name": "Hipragumboro-GM97",
    "country": "BE",
    "waitingTime": 0,
    "plukonId": 51
  },
  {
    "registrationNumber": "BE-V193593",
    "name": "Hipraviar NDV Clone",
    "country": "BE",
    "waitingTime": 0,
    "plukonId": 124
  },
  {
    "registrationNumber": "PEI.V.11884.01.1",
    "name": "HIPRAVIAR-B1",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 105
  },
  {
    "registrationNumber": "REG NL 115190",
    "name": "Innovax-ILT ",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 150
  },
  {
    "registrationNumber": "EU/2/15/182",
    "name": "Innovax-ILT ",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 206
  },
  {
    "registrationNumber": "REG NL 119940",
    "name": "Innovax-ND-IBD",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 142
  },
  {
    "registrationNumber": "EU/2/17/213",
    "name": "Innovax-ND-IBD",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 189
  },
  {
    "registrationNumber": "REG NL 125398",
    "name": "Innovax-ND-ILT ",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 151
  },
  {
    "registrationNumber": "EU/2/20/256",
    "name": "Innovax-ND-ILT ",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 188
  },
  {
    "registrationNumber": "PEI.V.11823.01.1",
    "name": "Cevac Mass L",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 110
  },
  {
    "registrationNumber": "EU/2/11/126/001",
    "name": "MS-H vaccin",
    "country": "BE",
    "waitingTime": 0,
    "plukonId": 125
  },
  {
    "registrationNumber": "REG NL 101401",
    "name": "Nemova Ivs",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 20
  },
  {
    "registrationNumber": "14",
    "name": "Nemova Ivs",
    "country": "BE",
    "waitingTime": 0,
    "plukonId": 54
  },
  {
    "registrationNumber": "PEI.V.04331.01.1",
    "name": "Nemovac",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 87
  },
  {
    "registrationNumber": "REG NL 8754",
    "name": "Nobilis Gumboro 228E",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 21
  },
  {
    "registrationNumber": "491a/93",
    "name": "Nobilis Gumboro 228E",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 88
  },
  {
    "registrationNumber": "15",
    "name": "Nobilis Gumboro 228E",
    "country": "BE",
    "waitingTime": 0,
    "plukonId": 55
  },
  {
    "registrationNumber": "REG NL 2370",
    "name": "Nobilis Gumboro D78",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 22
  },
  {
    "registrationNumber": "96a/83",
    "name": "Nobilis Gumboro D78",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 89
  },
  {
    "registrationNumber": "BE-V139054",
    "name": "Nobilis Gumboro D78",
    "country": "BE",
    "waitingTime": 0,
    "plukonId": 56
  },
  {
    "registrationNumber": "REG NL 9801",
    "name": "Nobilis IB 4-91 (EU/006)",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 23
  },
  {
    "registrationNumber": "EU/2/98/006/001-010",
    "name": "Nobilis IB 4-91 (EU/006)",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 90
  },
  {
    "registrationNumber": "EU/2/98/006/001-014",
    "name": "Nobilis IB 4-91 (EU/006)",
    "country": "BE",
    "waitingTime": 0,
    "plukonId": 57
  },
  {
    "registrationNumber": "REG NL 1439",
    "name": "Nobilis IB H120",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 24
  },
  {
    "registrationNumber": "A171/79",
    "name": "Nobilis IB H120",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 91
  },
  {
    "registrationNumber": "BE-V059385",
    "name": "Nobilis IB H120",
    "country": "BE",
    "waitingTime": 0,
    "plukonId": 58
  },
  {
    "registrationNumber": "REG NL 8106",
    "name": "Nobilis IB Ma5",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 25
  },
  {
    "registrationNumber": "PEI.V.11599.01.1",
    "name": "Nobilis IB Ma5",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 92
  },
  {
    "registrationNumber": "BE-V171981",
    "name": "Nobilis IB Ma5",
    "country": "BE",
    "waitingTime": 0,
    "plukonId": 59
  },
  {
    "registrationNumber": "REG NL 113557",
    "name": "Nobilis IB Primo QX",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 31
  },
  {
    "registrationNumber": "EU/2/14/174",
    "name": "Nobilis IB Primo QX",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 93
  },
  {
    "registrationNumber": "EU/2/14/174/001\u2013005",
    "name": "Nobilis IB Primo QX",
    "country": "BE",
    "waitingTime": 0,
    "plukonId": 65
  },
  {
    "registrationNumber": "REG NL 2653",
    "name": "Nobilis ILT",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 152
  },
  {
    "registrationNumber": "174a/80",
    "name": "Nobilis ILT",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 190
  },
  {
    "registrationNumber": "REG NL 8104",
    "name": "Nobilis Ma5\u002BClone30",
    "country": "NL",
    "waitingTime": 7,
    "plukonId": 26
  },
  {
    "registrationNumber": "190a/92",
    "name": "Nobilis Ma5\u002BClone30",
    "country": "DE",
    "waitingTime": 7,
    "plukonId": 94
  },
  {
    "registrationNumber": "20",
    "name": "Nobilis Ma5\u002BClone30",
    "country": "BE",
    "waitingTime": 7,
    "plukonId": 60
  },
  {
    "registrationNumber": "REG NL 10054",
    "name": "Nobilis ND C2",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 27
  },
  {
    "registrationNumber": "PEI.V.03204.01.01",
    "name": "Nobilis ND C2",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 95
  },
  {
    "registrationNumber": "BE-V281057 ",
    "name": "Nobilis ND C2",
    "country": "BE",
    "waitingTime": 0,
    "plukonId": 61
  },
  {
    "registrationNumber": "REG NL 1794",
    "name": "Nobilis ND Clone 30",
    "country": "NL",
    "waitingTime": 7,
    "plukonId": 28
  },
  {
    "registrationNumber": "490a/93",
    "name": "Nobilis ND Clone 30",
    "country": "DE",
    "waitingTime": 7,
    "plukonId": 96
  },
  {
    "registrationNumber": "BE-V112594",
    "name": "Nobilis ND Clone 30",
    "country": "BE",
    "waitingTime": 7,
    "plukonId": 62
  },
  {
    "registrationNumber": "REG NL 1793",
    "name": "Nobilis ND Lasota",
    "country": "NL",
    "waitingTime": 7,
    "plukonId": 143
  },
  {
    "registrationNumber": "BE-V059333",
    "name": "Nobilis ND Lasota",
    "country": "BE",
    "waitingTime": 0,
    "plukonId": 126
  },
  {
    "registrationNumber": "REG NL 10301",
    "name": "Nobilis Rhino CV",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 29
  },
  {
    "registrationNumber": "PEI.V.03207.01.1",
    "name": "Nobilis Rhino CV",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 97
  },
  {
    "registrationNumber": "BE-V281041",
    "name": "Nobilis Rhino CV",
    "country": "BE",
    "waitingTime": 0,
    "plukonId": 63
  },
  {
    "registrationNumber": "REG NL 2655",
    "name": "Nobilis Rismavac",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 115
  },
  {
    "registrationNumber": "188a/84",
    "name": "Nobilis Rismavac",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 191
  },
  {
    "registrationNumber": "BE-V096467",
    "name": "Nobilis Rismavac (Glas)",
    "country": "BE",
    "waitingTime": 0,
    "plukonId": 127
  },
  {
    "registrationNumber": "BE-V499422",
    "name": "Nobilis Rismavac (MLP-zak)",
    "country": "BE",
    "waitingTime": 0,
    "plukonId": 129
  },
  {
    "registrationNumber": "BE-V274757",
    "name": "Nobilis Rismavac (PE-zak)",
    "country": "BE",
    "waitingTime": 0,
    "plukonId": 128
  },
  {
    "registrationNumber": "REG NL 8869",
    "name": "Nobilis Rismavac \u002B CA 126",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 192
  },
  {
    "registrationNumber": "64a/96",
    "name": "Nobilis Rismavac \u002B CA 126",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 193
  },
  {
    "registrationNumber": "BE-V499431",
    "name": "Nobilis Rismavac \u002B CA 126  (MLP)",
    "country": "BE",
    "waitingTime": 0,
    "plukonId": 132
  },
  {
    "registrationNumber": "BE-V278406",
    "name": "Nobilis Rismavac \u002B CA 126 (Glas)",
    "country": "BE",
    "waitingTime": 0,
    "plukonId": 130
  },
  {
    "registrationNumber": "BE-V233213",
    "name": "Nobilis Rismavac \u002B CA 126 (PE)",
    "country": "BE",
    "waitingTime": 0,
    "plukonId": 131
  },
  {
    "registrationNumber": "REG NL 9123",
    "name": "Nobilis RTV 8544",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 30
  },
  {
    "registrationNumber": "24",
    "name": "Nobilis RTV 8544",
    "country": "BE",
    "waitingTime": 0,
    "plukonId": 64
  },
  {
    "registrationNumber": "371a/94",
    "name": "Nobilis Salenvac",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 194
  },
  {
    "registrationNumber": "REG NL 124766",
    "name": "Nobilis Salenvac ETC",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 195
  },
  {
    "registrationNumber": "PEI.V.12006.01.1",
    "name": "Nobilis Salenvac ETC",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 196
  },
  {
    "registrationNumber": "BE-V557617",
    "name": "Nobilis Salenvac ETC",
    "country": "BE",
    "waitingTime": 0,
    "plukonId": 197
  },
  {
    "registrationNumber": "REG NL 10136",
    "name": "Nobilis Salenvac T",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 133
  },
  {
    "registrationNumber": "PEI.V.02970.01.1",
    "name": "Nobilis Salenvac T",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 198
  },
  {
    "registrationNumber": "BE-V266305",
    "name": "Nobilis Salenvac T",
    "country": "BE",
    "waitingTime": 0,
    "plukonId": 199
  },
  {
    "registrationNumber": "REG NL 9687",
    "name": "Paracox 5",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 32
  },
  {
    "registrationNumber": "PEI.V.01272.01.1",
    "name": "Paracox 5",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 98
  },
  {
    "registrationNumber": "BE-V211321",
    "name": "Paracox 5",
    "country": "BE",
    "waitingTime": 0,
    "plukonId": 66
  },
  {
    "registrationNumber": "REG NL 3070",
    "name": "Paracox 8",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 135
  },
  {
    "registrationNumber": "483a/91",
    "name": "Paracox 8",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 200
  },
  {
    "registrationNumber": "BE-V172541",
    "name": "Paracox 8",
    "country": "BE",
    "waitingTime": 0,
    "plukonId": 201
  },
  {
    "registrationNumber": "REG NL 104181",
    "name": "Poulvac Bursa Plus",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 33
  },
  {
    "registrationNumber": "PEI.V.04760.01.1",
    "name": "Poulvac Bursa Plus",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 83
  },
  {
    "registrationNumber": "BE-V380895",
    "name": "Poulvac Bursa Plus",
    "country": "BE",
    "waitingTime": 0,
    "plukonId": 67
  },
  {
    "registrationNumber": "REG NL 3907",
    "name": "Poulvac bursine 2",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 34
  },
  {
    "registrationNumber": "218a/96",
    "name": "Poulvac bursine 2",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 99
  },
  {
    "registrationNumber": "BE-V150674",
    "name": "Poulvac bursine 2",
    "country": "BE",
    "waitingTime": 0,
    "plukonId": 68
  },
  {
    "registrationNumber": "REG NL 109364",
    "name": "Poulvac E. coli",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 113
  },
  {
    "registrationNumber": "EU/2/12/140/001-008",
    "name": "Poulvac E. coli",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 114
  },
  {
    "registrationNumber": "EU/2/12/140/001-008",
    "name": "Poulvac E. coli",
    "country": "BE",
    "waitingTime": 0,
    "plukonId": 136
  },
  {
    "registrationNumber": "REG NL 1484",
    "name": "Poulvac IB H120",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 35
  },
  {
    "registrationNumber": "PEI.V.11696.01.1",
    "name": "Poulvac IB H120",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 202
  },
  {
    "registrationNumber": "PEI.V.00373.01.1",
    "name": "Poulvac IB MM",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 100
  },
  {
    "registrationNumber": "REG NL 10119",
    "name": "Poulvac IB MM\u002BArk",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 36
  },
  {
    "registrationNumber": "BE-V259375",
    "name": "Poulvac IB MM\u002BArk",
    "country": "BE",
    "waitingTime": 0,
    "plukonId": 70
  },
  {
    "registrationNumber": "REG NL 8446",
    "name": "Poulvac IB Primer",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 37
  },
  {
    "registrationNumber": "167a/88",
    "name": "Poulvac IB Primer",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 101
  },
  {
    "registrationNumber": "BE-V148111",
    "name": "Poulvac IB Primer",
    "country": "BE",
    "waitingTime": 0,
    "plukonId": 71
  },
  {
    "registrationNumber": "REG NL 113104",
    "name": "Poulvac IB QX",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 38
  },
  {
    "registrationNumber": "PEI.V.11668.01.1",
    "name": "Poulvac IB QX",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 102
  },
  {
    "registrationNumber": "BE-V438051",
    "name": "Poulvac IB QX",
    "country": "BE",
    "waitingTime": 0,
    "plukonId": 72
  },
  {
    "registrationNumber": "PEI.V.00375.01.1",
    "name": "Poulvac ND Hitchner B1",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 103
  },
  {
    "registrationNumber": "BE-V092242",
    "name": "Poulvac ND Hitchner B1",
    "country": "BE",
    "waitingTime": 0,
    "plukonId": 138
  },
  {
    "registrationNumber": "REG NL 8447",
    "name": "Poulvac NDW",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 39
  },
  {
    "registrationNumber": "PEI.V.11749.01.1",
    "name": "Poulvac NDW",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 104
  },
  {
    "registrationNumber": "BE-V467475",
    "name": "Poulvac NDW",
    "country": "BE",
    "waitingTime": 0,
    "plukonId": 73
  },
  {
    "registrationNumber": "REG NL 105775",
    "name": "Transmune",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 106
  },
  {
    "registrationNumber": "PEI.V.11421.01.1",
    "name": "Transmune",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 109
  },
  {
    "registrationNumber": "EU/2/02/032/001",
    "name": "Vaxxitek HVT \u002B IBD",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 203
  },
  {
    "registrationNumber": "EU/2/02/032/001-002",
    "name": "Vaxxitek HVT \u002B IBD",
    "country": "BE",
    "waitingTime": 0,
    "plukonId": 139
  },
  {
    "registrationNumber": "REG NL 115510",
    "name": "Vectormune ND",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 40
  },
  {
    "registrationNumber": "EU/2/15/188/001-003",
    "name": "Vectormune ND",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 108
  },
  {
    "registrationNumber": "REG NL 124047",
    "name": "Nextmune",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 166
  },
  {
    "registrationNumber": "REG NL 128282",
    "name": "evanovo",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 204
  },
  {
    "registrationNumber": "REG NL 123185",
    "name": "Gumbohatch",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 169
  },
  {
    "registrationNumber": "REG NL 123234",
    "name": "Ceva Rispens",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 205
  },
  {
    "registrationNumber": "",
    "name": "Poulvac La Sota",
    "country": "BE",
    "waitingTime": 0,
    "plukonId": 137
  }
]
